/**
 * 获取promise单例
 * @returns resolve, reject句柄, 以及promise本身
 */
export const myPromise = () => {
  let res;
  let rej;
  const p = new Promise((resolve, reject) => {
    res = resolve;
    rej = reject;
  });
  return { res, rej, p };
};
